export default (function (siteVariables) {
  return {
    borderColor: siteVariables.colors.white,
    backgroundColor: siteVariables.colors.black,
    backgroundColorHover: siteVariables.accessibleYellow,
    textColor: siteVariables.colors.white,
    textColorHover: siteVariables.colors.black,
    boxShadow: undefined,
    progressColor: siteVariables.accessibleGreen,
    progressHeight: 6
  };
});